<template>
  <div class="checkout-item">
    <div class="checkout-item__num" v-if="num">
      {{ num }}
    </div>
    <div v-if="imgSrc" class="checkout-item__image">
      <img :src="imgSrc" :alt="title" class="checkout-item__image__img" v-if="imgSrc" />
    </div>
    <div class="checkout-item__text">
      <div class="grid grid--gap2">
        <div class="grid__col12 grid__col9-tablet grid__col10-desktop">
          <m4-heading level="3" class="checkout-item__text__title">
            {{ title }}
          </m4-heading>
          <p class="checkout-item__text__subtitle" v-if="subtitle">
            {{ subtitle }}
          </p>
          <p v-if="note" class="checkout-item__text__note">
            {{ note }}
          </p>
        </div>
        <div class="grid__col12 grid__col3-tablet grid__col2-desktop checkout-item__text__price--grid">
          <div class="checkout-item__text__price">
            {{ price }}
          </div>
          <div class="checkout-item__actions">
            <m4-dialog
              v-if="computedEditLink"
              :title="editTitle"
              :submit-url="computedEditLink"
              :allow-close-by-clicking-on-bg="false"
              :btn-title="$t('change')"
              :btn-cancel-title="$t('close')"
              @onSubmitUrl="$emit('onClickEdit', newEditValue)"
            >
              <template v-slot:button>
                <m4-button
                  type="button"
                  variant="primary-text"
                  size="sm"
                  :title="editTitle"
                  class="checkout-item__actions__edit"
                >
                  {{ $t("edit") }}
                </m4-button>
              </template>
              <fieldset class="fieldset fieldset--inline fieldset--sm fieldset--light fieldset--w100 margin-b-none">
                <m4-form-field
                  v-if="editOptions && editOptions.length"
                  name="quantity"
                  type="select"
                  :options="editOptions"
                  v-model="newEditValue"
                ></m4-form-field>
                <m4-form-field v-else name="quantity" type="number" v-model="newEditValue"></m4-form-field>
                <m4-hint v-if="editMaxAllowedQuantityHint">{{ editMaxAllowedQuantityHint }}</m4-hint>
              </fieldset>
            </m4-dialog>
            <m4-button
              v-if="deleteLink"
              @click="$emit('onClickDelete', newEditValue)"
              tag="a"
              variant="danger-text"
              size="sm"
              :href="deleteLink"
              title="Delete item"
            >
              {{ $t("remove") }}
            </m4-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4CheckoutItem",
  data() {
    return {
      newEditValue: this.editValue
    };
  },
  props: {
    num: {
      type: String,
      required: false
    },
    imgSrc: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    note: {
      type: String,
      required: false
    },
    price: {
      type: String,
      required: true
    },
    editLink: {
      type: String,
      required: false
    },
    editTitle: {
      type: String,
      default: "Edit quantity"
    },
    editValue: {
      type: [String, Number],
      default: 1
    },
    editOptions: {
      type: Array
    },
    editMaxAllowedQuantityHint: {
      type: String
    },
    deleteLink: {
      type: String,
      required: false
    }
  },
  emits: ["onClickEdit", "onClickDelete"],
  computed: {
    computedEditLink() {
      return this.editLink ? this.editLink + "/" + (this.newEditValue ? this.newEditValue : 1) : null;
    }
  }
};
</script>
